module.exports = __webpack_public_path__ + "static/img/chart_title.dbe87f60.png";